import { useMutation, useQuery } from '@apollo/client';
import { message } from 'antd';
import { FC } from 'react';
import {
  CasesSendReportV1ChangeStatusContainerFileInfoFieldsFragment,
  CasesSendReportV1ChangeStatusContainerSendReportCaseV1Document,
  CasesSendReportV1ChangeStatusContainerSendReportCaseV1FieldsFragment,
  CasesSendReportV1ChangeStatusContainerSendReportCaseV1UpdateDocument,
  CasesSendReportV1ChangeStatusContainerStaffUserCurrentDocument,
  CasesSendReportV1ChangeStatusContainerStaffUserFieldsFragment,
  SendReportCaseV1UpdateInput
} from '../../../../../../generated';
import { useOid } from '../../../../../../hooks/useOid';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../../../../shared/utils/queryOptions';
import { ChangeStatus } from './change-status';

interface ChangeStatusContainerProps {
  caseId: string;
}

export const ChangeStatusContainer: FC<ChangeStatusContainerProps> = (props: ChangeStatusContainerProps) => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);
  

  const {
    data: caseStatusData,
    loading: caseStatusLoading,
    error: caseStatusError
  } = useQuery(CasesSendReportV1ChangeStatusContainerSendReportCaseV1Document, {
    variables: {
      sendReportCaseV1Id: props.caseId,
      fileName: 'verification-status-report.pdf'
    }
  });

  const { data: staffUserData, loading: staffUserLoading, error: staffUserError } = useQuery(CasesSendReportV1ChangeStatusContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  const [caseDataChangeStatus] = useMutation(CasesSendReportV1ChangeStatusContainerSendReportCaseV1UpdateDocument);

  const handleChangeStatus = async (values: SendReportCaseV1UpdateInput) => {
    try {
      const result = await caseDataChangeStatus({
        variables: {
          input: values
        }
      });
      if (result.data?.sendReportCaseV1Update.status.success !== true) {
        message.error(`Error changing case status : ${result.data?.sendReportCaseV1Update.status.errorMessage}`);
      } else {
        message.success('Status changed successfully');
      }
    } catch (error) {
      message.error(`Error changing case status : ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      loading={caseStatusLoading || staffUserLoading}
      error={caseStatusError || staffUserError}
      hasData={caseStatusData?.sendReportCaseV1 && staffUserData?.staffUserCurrent}
      hasDataComponent={
        <ChangeStatus
          data={{
            caseData: caseStatusData?.sendReportCaseV1 as CasesSendReportV1ChangeStatusContainerSendReportCaseV1FieldsFragment,
            userData: staffUserData?.staffUserCurrent as CasesSendReportV1ChangeStatusContainerStaffUserFieldsFragment,
            fileData: caseStatusData?.sendReportCaseV1?.fileByFileName as CasesSendReportV1ChangeStatusContainerFileInfoFieldsFragment
          }}
          onChangeStatus={handleChangeStatus}
        />
      }
    />
  );
};
